import checkmateApi from "../axios/checkmateApi"

export const getRoleList = async () => {
    const response = checkmateApi({
        method: 'GET',
        url: 'roles'
    });
    return response;
}
